import { useQuery } from "@tanstack/react-query";
import { Brain } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { ErrorView, LoadingView } from "@react/foundation/placeholder";

import { PageView } from "../../../shared/components/PageView.tsx";
import { useQueries } from "../../../shared/hooks/useQueries.ts";

import { CreateProjectForm } from "./CreateProjectForm.tsx";
import { ProjectCard } from "./ProjectCard.tsx";

export const ProjectsView: FC = () => {
  const { getMemoryProjectsQueryOptions } = useQueries();
  const projects = useQuery(getMemoryProjectsQueryOptions());

  if (projects.status === "pending") {
    return <LoadingView />;
  }

  if (projects.status === "error") {
    return <ErrorView description="Failed to load projects." />;
  }

  return (
    <PageView
      icon={<Brain />}
      subtitle="Group the memories an agent files and the triggers injecting them."
      title="Memory"
    >
      <div className="flex flex-col gap-6">
        <CreateProjectForm />
        <div className="flex flex-col gap-2">
          {projects.data.items.map(project => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </PageView>
  );
};
